import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';
import { useStockDiscoveryData } from './hooks/useStockDiscoveryData';
import MostActiveStocksWidget from './components/MostActiveStocksWidget';
import TopMoversWidget from './components/TopMoversWidget';
import YearlyHighLowWidget from './components/YearlyHighLowWidget';

const StockDiscoveryTab = () => {
  const { mostActive, movers, yearlyHigh, yearlyLow, loading } = useStockDiscoveryData();

  return (
    <Box sx={{ px: { xs: 1, lg: 3 }, pt: { xs: 0.5, lg: 1 }, pb: { xs: 1, lg: 3 }, maxWidth: '100%', margin: '0 auto' }}>
      {/* Most Active Stocks Section */}
      <MostActiveStocksWidget loading={loading} data={mostActive} />
      
      <Divider sx={{ mt: 0.5, mb: 2, opacity: 0.5 }} />

      <Grid container spacing={3}>
        {/* Top Movers (40%) and Yearly High/Low (60%) */}
        <Grid item xs={12} lg={5} sx={{ display: 'flex' }}>
          <Box sx={{ width: '100%' }}>
            <TopMoversWidget loading={loading} data={movers} />
          </Box>
        </Grid>
        
        <Grid item xs={12} lg={7} sx={{ display: 'flex' }}>
          <Box sx={{ width: '100%' }}>
            <YearlyHighLowWidget loading={loading} highData={yearlyHigh} lowData={yearlyLow} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StockDiscoveryTab;
